<script setup lang="ts">
import { computed, defineEmits } from 'vue'
import { storeToRefs } from 'pinia'

import { useCrossSectionStore } from '@/stores/crossSection'
import { useCrossSectionFilterStore } from '@/stores/crossSectionFilter'

import {
  calculationMethods,
  calculationTypes,
  favoriteOptions
} from '@/components/calculation-result/constants/filterInputKey'
import FilterOptionsPanel from '@/components/calculation-result/filter/FilterOptionsPanel.vue'

const emit = defineEmits(['apply-filter', 'clear-all-filter'])

const crossSectionStore = useCrossSectionStore()
const crossSectionFilterStore = useCrossSectionFilterStore()

const { baseCrossSectionFilterSet } = storeToRefs(crossSectionFilterStore)

const fetchLoading = computed(() => crossSectionStore.fetchLoading)
</script>

<template>
  <v-card width="450" max-height="500" flat>
    <v-card-text>
      <v-card-actions class="align-center">
        <v-row no-gutters class="align-center">
          <v-col class="d-flex justify-start mx-4"> Filters</v-col>
          <v-col class="d-flex justify-end mx-1">
            <v-btn
              class="text-none"
              variant="text"
              color="primary"
              @click="emit('clear-all-filter')"
              :disabled="fetchLoading"
            >
              Clear
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

      <v-expansion-panels
        class="overflow-y-auto"
        elevation="0"
        style="max-height: 30vh"
        flat
        focusable
        multiple
      >
        <FilterOptionsPanel
          title="Calculation Methods"
          :is-active="crossSectionFilterStore.activeCalculationMethodFilters"
          :options="calculationMethods"
          v-model="baseCrossSectionFilterSet.calculation_method"
        />

        <FilterOptionsPanel
          title="Calculation Types"
          :is-active="crossSectionFilterStore.activeCalculationTypeFilters"
          :options="calculationTypes"
          v-model="baseCrossSectionFilterSet.calculation_type"
        />

        <FilterOptionsPanel
          title="View Favorite"
          :is-active="crossSectionFilterStore.activeFavoriteFilters"
          :options="favoriteOptions"
          v-model="baseCrossSectionFilterSet.favorite"
        />
      </v-expansion-panels>

      <v-divider class="my-4"></v-divider>

      <v-card-actions>
        <v-btn
          class="text-none mx-4 px-4"
          variant="tonal"
          color="primary"
          :loading="fetchLoading"
          @click="emit('apply-filter')"
        >
          Apply Filter
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
